/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { Plate } from "src/classes/plate/Plate";
import { DragCanvasSession, SessionType } from "src/classes/plate/Session";
import { DragRect } from "src/components/Plate/Canvas/DragRect";
interface Props {
  plate: Plate;
}
export function DragListener({ plate }: Props) {
  const isCurrentSession = plate.sessionManager.observe((state) => state.isCurrentSession);
  return isCurrentSession && plate.sessionManager.currentSession!.snapshot.type === SessionType.DragCanvas ? (
    <DragRect session={plate.sessionManager.currentSession as DragCanvasSession} />
  ) : (
    <></>
  );
}
